import { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  trend?: {
    value: number; // Percentage (positive or negative)
    isPositive: boolean;
  };
  icon?: ReactNode;
  className?: string;
}

export default function StatCard({ label, value, trend, icon, className = '' }: StatCardProps) {
  return (
    <div
      className={`
        border-2 border-black dark:border-gray-600 rounded-lg p-4
        bg-white dark:bg-gray-800
        shadow-brutal hover:shadow-brutal-hover
        transition-all duration-200
        ${className}
      `}
    >
      {/* Icon (optional, top-left) */}
      {icon && (
        <div className="text-2xl mb-2">
          {icon}
        </div>
      )}

      {/* Value */}
      <div className="flex items-baseline gap-2 mb-1">
        <span className="text-3xl font-bold dark:text-gray-100">
          {value}
        </span>

        {/* Trend Indicator */}
        {trend && (
          <span
            className={`
              text-sm font-medium flex items-center gap-1
              ${trend.isPositive ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}
            `}
          >
            {/* Arrow Icon */}
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              {trend.isPositive ? (
                // Up arrow
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                />
              ) : (
                // Down arrow
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
                />
              )}
            </svg>

            {/* Percentage */}
            {Math.abs(trend.value)}%
          </span>
        )}
      </div>

      {/* Label */}
      <p className="text-sm text-gray-600 dark:text-gray-400 font-medium">
        {label}
      </p>
    </div>
  );
}
